/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';

const InputFieldWrapper = styled(TextField)({
  '&': {
    backgroundColor: '#fff',
    minWidth: 420,
    '@media (max-width: 767px)': {
      minWidth: 'auto',
    },
  },
});

function NewInputField(props) {
  return <InputFieldWrapper variant="standard" size="small" {...props} />;
}

export default NewInputField;
